import { IDraggableSidebarItemUnresolved } from "../../controls";
import { CURRENT_HIERARCHY_ID } from "../contexts";
import { ArsSidebarItemGroupingFactor, ArsSidebarItemKind } from "./interface";

const PLACEHOLDERLABEL = "Placeholder";
const PLACEHOLDERDESCRIPTION = "Blank placeholder for display only";
export const PLACEHOLDERGROUPINGFACTOR = "__placeholder__";

export interface TotalGroupingFactorSidebarItemProps {
  selected?: boolean;
}

export const totalSidebarItem: IDraggableSidebarItemUnresolved<ArsSidebarItemGroupingFactor> = {
  id: "placeholder-sidebar-item",
  label: PLACEHOLDERLABEL,
  data: () => ({
    kind: ArsSidebarItemKind.GroupingFactor,
    dropItem: {
      id: crypto.randomUUID(),
      name: PLACEHOLDERGROUPINGFACTOR,
      label: PLACEHOLDERLABEL,
      description: PLACEHOLDERDESCRIPTION,
      groups: [],
      dataDriven: false,
      fromHierarchyId: CURRENT_HIERARCHY_ID,
    },
  }),
};

/**
 * Custom sidebar item renderer for total grouping factor.
 *
 * @param props - Props containing the selection state
 * @param props.selected - Whether the item is currently selected
 * @returns Total grouping factor display element
 */
export const TotalGroupingFactorSidebarItem = ({
  selected,
}: TotalGroupingFactorSidebarItemProps) => {
  return (
    <div
      className={`px-2 py-1 border rounded w-100 ${selected ? "border-primary bg-primary-subtle" : ""}`}
      style={{ cursor: "grab" }}
    >
      <div className="fw-semibold">{PLACEHOLDERLABEL}</div>
      <small className="text-muted">{PLACEHOLDERDESCRIPTION}</small>
    </div>
  );
};

TotalGroupingFactorSidebarItem.displayName = "TotalGroupingFactorSidebarItem";
